<template>
  <div
    class="pb-4 lg:!grid lg:!grid-cols-3"
    :class="{ 'lg:!-mx-4': width === 'full' }"
  >
    <div
      :class="[
        proportion === '66-33' ? 'col-span-2 lg:!grid lg:!grid-cols-2 auto-rows-min' : '',
        proportion === '33-66' ? 'col-span-1 auto-rows-min' : '',
        'h-fit pb-4 lg:!py-0 lg:!pr-4 min-h-full',
        width === 'full' ? 'w-full' : ''
      ]"
    >
      <slot name="one" />
    </div>
    <div
      :class="[
        proportion === '66-33' ? 'col-span-1 auto-rows-min' : '',
        proportion === '33-66' ? 'col-span-2 lg:!grid lg:!grid-cols-2 auto-rows-min' : '',
        'border-t border-gray-100 dark:border-gray-800 lg:!border-t-0 lg:!border-l',
        'w-full h-fit lg:!pl-4 pt-4 lg:!py-0 min-h-full',
        width === 'auto' ? 'min-w-72' : '',
      ]"
    >
      <slot name="two" />
    </div>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ColTwo"
})

defineProps({
  proportion: { type: String, default: '33-66' },
  width: { type: String, default: 'full' }
})
</script>
